<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show" title="调价" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="100px" size="mini">
				<el-form-item label="单据编码">
					<el-input readonly v-model="form.stockCode"></el-input>
				</el-form-item>
				<el-form-item label="仓库">
					<el-input readonly v-model="form.storageName"></el-input>
				</el-form-item>
				<el-form-item label="产品编码">
					<el-input readonly v-model="form.goodscode"></el-input>
				</el-form-item>
				<el-form-item label="调整价格">
					<el-input-number :precision="4" :step="0.01" v-model="form.priceadjust"></el-input-number>
				</el-form-item>
				<el-form-item label="调价原因" required>
					<el-select v-model="form.reason" placeholder="请选择" @change="reasonChange">
						<el-option label="供应商开错单" value="供应商开错单"></el-option>
						<el-option label="供应商涨跌价" value="供应商涨跌价"></el-option>
						<el-option label="质检入库错误" value="质检入库错误"></el-option>
						<el-option label="其他原因" value="其他原因"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="自定义备注" required>
					<el-input v-model="form.custommark"></el-input>
				</el-form-item>
				<el-form-item label="附件" :required="fileRequired">
					<upload v-model="form.file"  :formCreateInject="true" />
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			}

		},
		data() {
			return {
				oldprice: 0,
				modal: false,
				loading: false,
				tableData: [],
				fileRequired:false,
				form: {
					stockCode: null,
					storageName: null,
					goodscode: null,
					priceadjust: 0,
					reason: null,
					file: [],
					custommark:null
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			reasonChange(e){

				this.fileRequired = false
				if(e == '供应商开错单' || e == '供应商涨跌价' || e == '其他原因'){
					this.fileRequired = true
				}
			},
			init() {
				this.form.stockCode = this.row.stockCode
				this.form.storageName = this.row.storageName
				this.form.goodscode = this.row.goodscode
				this.form.priceadjust = this.row.newprice
				this.form.reason = null
				this.form.file = []
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			submit() {
				if(!this.form.reason){
					this.$message.error('调价原因必填')
					return
				}
				if(this.form.reason == '供应商开错单' || this.form.reason == '供应商涨跌价' || this.form.reason == '其他原因'){
					if(!this.form.file || !this.form.file.length){
						this.$message.error('附件必填')
						return
					}
				}
				let percent = ((this.form.priceadjust - this.row.price1) / this.row.price1 * 100).toFixed(2)
				this.$confirm("是否确认调整价格为" + this.form.priceadjust + " 波动修正为" + percent + "%", "提示").then(() => {
					let handle = this.$loading()
					this.$api.pricefluctuations.adjust({
						id: this.row.id,
						priceadjust: this.form.priceadjust,
						goodscode: this.form.goodscode,
						reason: this.form.reason,
						file: this.form.file,
						custommark: this.form.custommark,
						storageUid: this.row.storageID
					}).then(() => {
						this.$loadingclose(handle)
						this.$message.success('操作成功')
						this.$emit('success', {
							newprice: this.form.priceadjust
						})
						this.cancel()
					}, () => {
						this.$loadingclose(handle)
					})
				})





				//this.cancel()
			},

		},
		components: {
			upload
		}
	}
</script>